var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBosch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 57.2,
    xmlSpace: "preserve",
    viewBox: "-374 472.8 250 57.2",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg24885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.6248 0 0 -2.6248 -1195.666 796.667)",
    id: "g26531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "q57"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.336 0 0 .336 407.906 266.21)",
    id: "xfrm58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-247.9-469.6c0 3.6-2.6 6-8.1 6h-11.1v-12.2h11.3c4.6.1 7.9 1.8 7.9 6.2zm-2 24.2c0 3.5-2.4 5.8-5.9 5.8h-11.3v-11.5h11.1c3.9 0 6.1 2.9 6.1 5.7zm18.5-25.9c0-10.4-9.6-17.3-19.3-17.3h-31.6v61.9h29c11.1 0 19.2-5.6 19.2-17 0-9.8-8.5-12.7-8.5-12.7-.1-.1 11.2-2.7 11.2-14.9",
    fill: "#ec1b24",
    id: "path3190"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "q59"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.336 0 0 .336 407.906 266.21)",
    id: "xfrm60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-184.1-457.6c0 9.7-4.4 17.5-13.2 17.5-8.8 0-13.1-7.9-13.1-17.5 0-9.8 4.4-17.6 13.1-17.6 8.8 0 13.2 7.8 13.2 17.6zm15.2 0c0-18.2-10.4-32.4-28.4-32.4-17.9 0-28.4 14.3-28.4 32.4 0 18.1 10.5 32.4 28.4 32.4 18 0 28.4-14.3 28.4-32.4",
    fill: "#ec1b24",
    id: "path3194"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "q61"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.336 0 0 .336 407.906 266.21)",
    id: "xfrm62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-115.7-469.8c0-13.6-12.3-20.2-23.9-20.2-13.4 0-20.3 5.1-25.7 11.6l9.9 9.7c4.2-5.3 9.6-8 15.7-8 5 0 8.3 2.5 8.3 6.1 0 3.9-3 5.2-11.1 6.9l-2.2.5c-9.8 2-17.8 7.6-17.8 18.6 0 12.2 9.9 19.5 22.9 19.5 11 0 18.2-4.8 22.6-9.7l-9.6-9.5c-3 3.2-7.5 5.8-12.7 5.8-3.5 0-7.5-1.6-7.5-5.8 0-3.7 4.1-5.1 9.4-6.2l2.2-.5c8.8-1.9 19.5-4.6 19.5-18.8",
    fill: "#ec1b24",
    id: "path3198"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "q63"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.336 0 0 .336 407.906 266.21)",
    id: "xfrm64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-56.9-476.6c-6.3-9.1-12.2-13.4-24.5-13.4-17.4 0-28.6 14.4-28.6 32.8 0 17.5 10.1 32 28.8 32 10.2 0 17.6-4 23.8-13.4l-12.5-8.3c-2.5 4.4-5.8 6.9-11.2 6.9-6.9 0-13.5-6.2-13.5-17.2 0-12.4 7.2-18 14-18 5.9 0 8.6 2.9 11.1 7.1l12.6-8.5",
    fill: "#ec1b24",
    id: "path3202"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "q65"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.336 0 0 .336 407.906 266.21)",
    id: "xfrm66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.1-488.6h-16.3v24.4H-34v-24.4h-16.2v61.9H-34v-22.8h18.8v22.8H1.1v-61.9",
    fill: "#ec1b24",
    id: "path3206"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosch);
export default __webpack_public_path__ + "static/media/bosch.f489362a99af58e125389bf0d1a5824e.svg";
export { ForwardRef as ReactComponent };